import { render, staticRenderFns } from "./Datasource.vue?vue&type=template&id=5cdd3af4"
import script from "./Datasource.vue?vue&type=script&lang=js"
export * from "./Datasource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports